import {
  Box,
  Button,
  Chip,
  Pagination,
  PaginationItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { InfluencerStatus } from "../../../../utils/constants";
import AffiliatedIcon from "../../../Assets/Img/affilicated-icon.svg";
import { useUpdateInfluencerStatus } from "../../../hooks/admin/useUpdateInfluencerStatus";

export const InfluencersList = ({
  state,
  data,
  containerSx = {},
  currentPage,
  onPageChange,
  total,
  onUpdate,
}) => {
  const { updateInfluencerStatus, loading } = useUpdateInfluencerStatus();

  return (
    <Box
      sx={{
        ...containerSx,
        display: "flex",
        gap: "1rem",
        flexDirection: "column",
      }}
    >
      <TableContainer
        sx={{
          marginTop: "8px",
          height: "100%",
          zIndex: 0,
          ...containerSx,
        }}
      >
        <Table
          sx={{ "& .MuiTableCell-root": { borderBottom: "none" } }}
          stickyHeader
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  background: "#F5F2E7",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                }}
              >
                Influencers
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                Affiliated with
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                E-mails
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                Phone
              </TableCell>
              <TableCell sx={{ background: "#F5F2E7" }} align="center">
                Registered Date
              </TableCell>
              {state === "approved" ? (
                <TableCell sx={{ background: "#F5F2E7" }} align="center">
                  Status
                </TableCell>
              ) : (
                <></>
              )}
              <TableCell
                sx={{
                  background: "#F5F2E7",
                  borderTopRightRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
                align="center"
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              marginTop: "8px",
            }}
          >
            {data.map((d) => (
              <TableRow
                key={d.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  height: "80px",
                }}
              >
                <TableCell>
                  <Box display={"flex"} alignItems={"center"} gap={1}>
                    {d.profile ? (
                      <img
                        src={d.profile}
                        alt=""
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "25px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "25px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#e8e8e8",
                        }}
                      >
                        <Typography fontWeight={700} letterSpacing={0.4}>
                          {[d.first_name, d.last_name]
                            .filter(Boolean)
                            .map((name) => name[0].toUpperCase())
                            .join("")}
                        </Typography>
                      </Box>
                    )}
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "#3D3D3D",
                        }}
                      >
                        {[d.first_name, d.last_name].filter(Boolean).join(" ")}
                      </Typography>
                      <Typography sx={{ fontSize: "12px", color: "#9D9D9D" }}>
                        {d.username}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  {d.source === "admin" ? (
                    <img
                      src={AffiliatedIcon}
                      alt=""
                      style={{
                        width: "24px",
                        height: "24px",
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </TableCell>
                <TableCell align="center">{d.email}</TableCell>
                <TableCell align="center">{d.phone_no}</TableCell>
                <TableCell align="center">
                  {d?.created_at
                    ? dayjs(+d.created_at).format("DD/MM/YYYY HH:mm A")
                    : "N/A"}
                </TableCell>
                {state === "approved" ? (
                  <TableCell align="center">
                    <Chip
                      variant="filled"
                      label={InfluencerStatus?.[d.approve_status]?.label}
                      sx={{
                        backgroundColor:
                          InfluencerStatus?.[d.approve_status]?.background,
                        color: InfluencerStatus?.[d.approve_status]?.color,
                      }}
                    />
                  </TableCell>
                ) : (
                  <></>
                )}
                <TableCell align="center">
                  <Box
                    display={"flex"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    {state === "approved" ? (
                      <Button
                        variant="outlined"
                        sx={{
                          color: "#CD0B0B",
                          fontSize: "14px",
                          borderColor: "#CD0B0B !important",
                        }}
                        loading={loading}
                        disabled={loading}
                        onClick={() => {
                          updateInfluencerStatus(
                            {
                              id: d.user_id,
                              status: "deleted",
                            },
                            onUpdate
                          );
                        }}
                      >
                        Delete
                      </Button>
                    ) : (
                      <></>
                    )}
                    {state === "pending" ? (
                      <Button
                        variant="text"
                        sx={{ color: "#CD0B0B", fontSize: "14px" }}
                        loading={loading}
                        disabled={loading}
                        onClick={() => {
                          updateInfluencerStatus(
                            {
                              id: d.user_id,
                              status: "declined",
                            },
                            onUpdate
                          );
                        }}
                      >
                        Decline
                      </Button>
                    ) : (
                      <></>
                    )}
                    {state === "pending" || state === "declined" ? (
                      <Button
                        variant="outlined"
                        sx={{ color: "#6b8e76", fontSize: "14px" }}
                        loading={loading}
                        disabled={loading}
                        onClick={() => {
                          updateInfluencerStatus(
                            {
                              id: d.user_id,
                              status: "approved",
                            },
                            onUpdate
                          );
                        }}
                      >
                        Approve
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {total ? (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <Pagination
            count={total}
            showFirstButton
            showLastButton
            page={currentPage}
            onChange={(_, page) => {
              onPageChange(page);
            }}
            sx={{
              "& button": {
                border: "none !important",
              },
            }}
            shape="circular"
            renderItem={(item) => (
              <PaginationItem
                slots={{
                  first: MdKeyboardDoubleArrowLeft,
                  last: MdKeyboardDoubleArrowRight,
                }}
                {...item}
              />
            )}
          />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};
